export const formatZipCode = (number: string) => {
  let zipCode = number.replace(/\D/g, '');
  if (zipCode.length > 3) zipCode = zipCode.replace(/.{3}/, '$&-');
  return zipCode;
};
